// extracted by mini-css-extract-plugin
export default {"paginationContainer":"RV7cJQwRiJ2U5rReO1Nz","top":"APDcXora8jcE0nzekTFA","right":"vLnIEPIyb4UTbKXEuGJx","pagination":"D8WW6HDnkKOTfMUkRRDB"};